import React from 'react';
import TeaserRow from "./TeaserRow";
import MiniVideo, {MiniVideoPlaceholder} from "./MiniVideo";
import VideoTeaser, { VideoPlaceholder } from "./VideoTeaser";
import MiniList from "./MiniList";
import dataFetch from "./DataFetch";

export class VideoRow extends React.PureComponent {
  render() {
    let { items } = this.props;
    items = items.filter(item => !!item.full_length);

    if (this.props.mobileView) {
      return <MiniList
        Item={MiniVideo}
        ItemPlaceholder={MiniVideoPlaceholder}
        {...this.props}
        items={items}
      />;
    } else {
      return <TeaserRow
        Item={VideoTeaser}
        ItemPlaceholder={VideoPlaceholder}
        {...this.props}
        itemProps={this.props.itemProps}
        items={items}
      />;
    }
  }
}

export default dataFetch(VideoRow);